import React, { useEffect, useState } from "react";
import { Loader2, Smartphone } from "lucide-react";
import { useParams } from "react-router-dom";
import { buildApiUrl } from "../services/apiHelpers";

const resolveAppointmentId = (rawAppointmentId) => {
  if (!rawAppointmentId) return "";

  let decodedId = rawAppointmentId;
  try {
    decodedId = decodeURIComponent(rawAppointmentId);
  } catch (error) {
    return "";
  }

  const malformedMetaId = decodedId.match(/^\{\{1\}\}(\d+)$/);
  if (malformedMetaId) return malformedMetaId[1];

  return /^\d+$/.test(decodedId) ? decodedId : "";
};

export default function UpiPaymentRedirectPage() {
  const { appointmentId } = useParams();
  const [error, setError] = useState("");
  const resolvedAppointmentId = resolveAppointmentId(appointmentId);

  useEffect(() => {
    let cancelled = false;

    const openUpiApp = async () => {
      try {
        const response = await fetch(buildApiUrl(`payment-utils/upi-uri/${resolvedAppointmentId}`), {
          credentials: "omit",
          headers: { Accept: "application/json" },
        });
        const payload = await response.json().catch(() => ({}));

        if (!response.ok || !payload.success || !payload.upiUri) {
          throw new Error(payload.message || "Unable to create the UPI payment link.");
        }

        if (!cancelled) {
          window.location.replace(payload.upiUri);
        }
      } catch (redirectError) {
        if (!cancelled) setError(redirectError.message || "Unable to open a UPI app.");
      }
    };

    if (!resolvedAppointmentId) {
      setError("Payment appointment reference is missing.");
    } else {
      openUpiApp();
    }

    return () => {
      cancelled = true;
    };
  }, [resolvedAppointmentId]);

  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, background: "linear-gradient(135deg, #effcfb, #f8fafc)", fontFamily: "DM Sans, sans-serif", color: "#164e63" }}>
      <section style={{ width: "min(100%, 420px)", padding: 30, textAlign: "center", border: "1px solid #cfe5e6", borderRadius: 20, background: "#fff", boxShadow: "0 20px 55px rgba(15, 76, 92, .12)" }}>
        <div style={{ width: 52, height: 52, margin: "0 auto 16px", display: "grid", placeItems: "center", borderRadius: 15, background: "#dff5f2", color: "#087f7a" }}>
          {error ? <Smartphone size={25} /> : <Loader2 size={25} className="upi-redirect-spin" />}
        </div>
        <h1 style={{ margin: 0, fontSize: 22, color: "#173d4d" }}>{error ? "Unable to open UPI" : "Opening your UPI app"}</h1>
        <p style={{ margin: "10px 0 0", lineHeight: 1.6, color: "#688091", fontSize: 14 }}>
          {error || "Please wait while we prepare your secure payment request."}
        </p>
        <style>{`.upi-redirect-spin{animation:upi-redirect-spin .8s linear infinite}@keyframes upi-redirect-spin{to{transform:rotate(360deg)}}`}</style>
      </section>
    </main>
  );
}
